const INITIAL_STATE = {
  ref: {
    bodyText: '',
  },
};

export default {
  namespaced: true,

  state: { ...INITIAL_STATE },

  mutations: {
    resetState(state) {
      Object.assign(state, INITIAL_STATE);
    },
  },

  getters: {
    getRefData: (state) => {
      return state.ref;
    },
  },
};
